<template>
  <div class="c-main-container">
    <h1>各種設定</h1>
    <div>

      <div class="setting-container-position mt20">
        <div class="head">登録情報</div>
      </div>
      <div class="setting-container">
        <span class="head">登録名</span>: {{user.name}}<br>
        <span class="head">メールアドレス</span>: {{user.email}}
      </div>

      <div class="setting-container-position mt20">
        <div class="head">各種変更</div>
      </div>
      <div class="setting-container">

        <div class="item">
          <UserChangeEmail/>
        </div>
        <div class="item">
          <UserChangeName @callback="callback"/>
        </div>
        <div class="item">
          <UserChangePassword/>
        </div>
      </div>

      <div class="setting-container-position mt20">
        <div class="head">その他</div>
      </div>
      <div class="setting-container">

        <div class="item">
          <UserUnregister/>
        </div>
      </div>

      <div v-if="$isDebug()" class=" debug-info">
        <div class="setting-container-position">
          <div class="head">Debug</div>
        </div>
        <div class="setting-container">
          <div @click="userInfoUpdate" class="link"><i class="fas fa-angle-right"></i> ユーザー情報を更新</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import UserChangeEmail from '@/components/user/UserChangeEmail';
import UserChangeName from '@/components/user/UserChangeName';
import UserChangePassword from '@/components/user/UserChangePassword';
import UserUnregister from '@/components/user/UserUnregister';

export default {
  components: {
    UserChangeEmail,
    UserChangeName,
    UserChangePassword,
    UserUnregister
  },
  data () {
    return {
      lock: false
    };
  },
  watch: {
    lock: function () {

      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    }
  },
  computed: {
    user: function () {
      return this.$store.getters['auth/userInfo'];
    }
  },
  methods: {
    callback: function (dispatch, value) {
      console.log('callback', dispatch, value);

      if (dispatch === 'nameChange') {
        this.userInfoUpdate();
      }

    },
    userInfoUpdate: function () {
      this.lock = true;

      this.$store.dispatch('auth/info').then(() => {

        let status = this.$store.getters['auth/status'];

        if (status !== 200) {
          this.$store.dispatch('errorInfo/setErrorStore', 'auth').then();
          this.$router.push({name: 'UserSystemError'});
        }

        // ロック解除
        this.lock = false;

      }).catch((err) => {
        console.log(err);

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();
        this.$router.push({name: 'UserSystemError'});

        // ロック解除
        this.lock = false;

      });
    }
  }
};

</script>

<style lang="scss" scoped>

  form,
  .setting-container {
    border: 1px solid #ddd;
    padding: 20px;
    width: 500px;

  }

  h2 {
    font-size: 14px;
    border-left: 5px solid #ddd;
    padding-left: 10px;
    line-height: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .input {
    margin: 5px;
    .head {
      display: inline-block;
      width: 120px;
    }
  }

  .setting-container-position {
    position: relative;
    background: #0f0;

    .head {
      position: absolute;
      top: -10px;
      left: 10px;
      padding: 0 10px;
      background: #fff;
    }
  }

  .setting-container {
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 20px;

    .item {
      margin: 3px;
      position: static;
    }

    .link {
      cursor: pointer;
    }

    .head {
      display: inline-block;
      width: 120px;
    }

  }

  .debug-info {
    margin-top: 50px;
  }

  // 801以上
  @media screen and (min-width: 801px) {
    .setting-container {
      width: 100%;
      max-width: 700px;
    }
  }

  // 800まで
  @media screen and (max-width: 800px) {
    .setting-container {
      width: 100%;
    }
  }

</style>
